import { c as _c } from "react-compiler-runtime";
import { useState, useMemo, useRef, useEffect, useId } from 'react';
import { CellSelectionEffects } from '../../cellSelection/components/CellSelectionEffects';
import { Provider } from 'react-redux';
import { createStore } from '../../redux/createStore';
import { StoreContext } from '../../redux/storeContext';
import { createWidthsStore } from '../../redux/createWidthsStore';
import { createSelectionStore } from '../../redux/createSelectionStore';
import { createCellSelectionStore } from '../../redux/createCellSelectionStore';
import { WidthsStoreContext } from '../../redux/widthsStoreContext';
import { SelectionStoreContext } from '../../redux/selectionStoreContext';
import { ProvideCellSelection } from '../../cellSelection/context/CellSelectionContext';
import { EmptyComponent } from '../utils/EmptyComponent';
import { DEFAULT_PAGE_SIZES } from '../../pagination/constants/pageSizes';
import emptyFunction from 'react-utils/emptyFunction';
import Table from './Table';
import { ProvideAuth } from '../../auth/context/AuthContext';
import { DEFAULT_COLUMN_MINIMUM_WIDTH, DEFAULT_COLUMN_WIDTH, MINIMUM_RESIZABLE_COLUMN_WIDTH } from '../constants/sizes';
import { DefaultRowComponent } from './DefaultRowComponent';
import { DefaultTableComponent } from './DefaultTableComponent';
import { ProvideLogger } from '../../logger/context/LoggerContext';
import { ProvideFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { ProvideColumnCallToAction } from '../columnCallToAction/ColumnCallToActionContext';
import { useResolvedColumnCallToAction } from '../columnCallToAction/useResolvedColumnCallToAction';
import DefaultSelectAllComponent from '../../selection/components/DefaultSelectAllComponent';
import { ProvideVirtualization } from '../../virtualization/VirtualizationContext';
import { useAdjustCtaColumnWidth } from '../columnCallToAction/useAdjustCtaColumnWidth';
import { getColumnKey } from '../utils/getColumnKey';
import Raven from 'raven-js';
import { BulkActionsContainerAboveTable } from './BulkActionsContainerAboveTable';
import { infiniteScrollDisabled } from '../../infiniteScroll/config';
import { rightToolbarDisabled } from '../../rightToolbar/config';
import { cellSelectionDisabled, CELL_SELECTION_CONFIG_TYPES, isCellSelectionEnabled } from '../../cellSelection/config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const emptyArray = [];
const DEFAULT_NAMESPACE = 'DEFAULT_NAMESPACE';

//we explicitly prevent a column width of 0 - this || is weight bearing over ??
const getMinimumColumnWidth = column => Math.max(column.minimumColumnWidth || DEFAULT_COLUMN_MINIMUM_WIDTH,
// Below MINIMUM_RESIZABLE_COLUMN_WIDTH, users can no longer interact with column resizing and can get stuck with a too-narrow column
column.resizable ? MINIMUM_RESIZABLE_COLUMN_WIDTH : 0);
const TableWrapper = t0 => {
  const $ = _c(124);
  const {
    alternateHeaderLeftSlot: t1,
    BulkActionsComponent: t2,
    canSelectAllRecords: t3,
    columns,
    CustomSelectAllComponent: t4,
    tableResetKey,
    getRowId,
    hasGate,
    hasScope,
    headerLeftSlot: t5,
    headerRightSlot: t6,
    infiniteScrollConfig: t7,
    isBulkActionsRedesignEnabled: t8,
    isIndexRedesignEnabled: t9,
    loading: t10,
    logger: t11,
    noRowsSlot: t12,
    numberOfFrozenColumns: t13,
    onColumnOrderChange: t14,
    onColumnWidthChange: t15,
    contextMenuConfig,
    columnCallToAction,
    onPageIndexChange: t16,
    onPageSizeChange: t17,
    onSortsChange: t18,
    pageable: t19,
    pageIndex: t20,
    pageSize: t21,
    pageSizes: t22,
    maxVisiblePageButtons,
    paginatorAlignment: t23,
    reorderable: t24,
    resizable: t25,
    rows,
    RowComponent: t26,
    scrollContainerRef,
    selectable: t27,
    selectionStore: externalSelectionStore,
    cellSelectable: t28,
    cellSelectionConfig,
    sortable: t29,
    sorts: t30,
    TableComponent: t31,
    totalRowCount: t32,
    zebraStripe: t33,
    condensed: t34,
    dataDensity,
    enableFullVirtualization: t35,
    onFrozenColumnWidthAlert,
    hasTopBarBorderRadius,
    borderless: t36,
    rightToolbarConfig: t37
  } = t0;
  const alternateHeaderLeftSlot = t1 === undefined ? null : t1;
  const BulkActionsComponent = t2 === undefined ? EmptyComponent : t2;
  const canSelectAllRecords = t3 === undefined ? true : t3;
  const CustomSelectAllComponent = t4 === undefined ? DefaultSelectAllComponent : t4;
  const headerLeftSlot = t5 === undefined ? null : t5;
  const headerRightSlot = t6 === undefined ? null : t6;
  const infiniteScrollConfig = t7 === undefined ? infiniteScrollDisabled : t7;
  const isBulkActionsRedesignEnabled = t8 === undefined ? false : t8;
  const isIndexRedesignEnabled = t9 === undefined ? false : t9;
  const loading = t10 === undefined ? false : t10;
  const logger = t11 === undefined ? emptyFunction : t11;
  const noRowsSlot = t12 === undefined ? null : t12;
  const numberOfFrozenColumns = t13 === undefined ? 0 : t13;
  const onColumnOrderChange = t14 === undefined ? emptyFunction : t14;
  const onColumnWidthChange = t15 === undefined ? emptyFunction : t15;
  const onPageIndexChange = t16 === undefined ? emptyFunction : t16;
  const onPageSizeChange = t17 === undefined ? emptyFunction : t17;
  const onSortsChange = t18 === undefined ? emptyFunction : t18;
  const pageable = t19 === undefined ? true : t19;
  const pageIndex = t20 === undefined ? 0 : t20;
  const pageSize = t21 === undefined ? DEFAULT_PAGE_SIZES[0] : t21;
  const pageSizes = t22 === undefined ? DEFAULT_PAGE_SIZES : t22;
  const paginatorAlignment = t23 === undefined ? "center" : t23;
  const reorderable = t24 === undefined ? true : t24;
  const resizable = t25 === undefined ? true : t25;
  const RowComponent = t26 === undefined ? DefaultRowComponent : t26;
  const selectable = t27 === undefined ? true : t27;
  const cellSelectable = t28 === undefined ? false : t28;
  const sortable = t29 === undefined ? true : t29;
  const sorts = t30 === undefined ? emptyArray : t30;
  const TableComponent = t31 === undefined ? DefaultTableComponent : t31;
  const totalRowCount = t32 === undefined ? 0 : t32;
  const zebraStripe = t33 === undefined ? false : t33;
  const condensed = t34 === undefined ? true : t34;
  const enableFullVirtualization = t35 === undefined ? false : t35;
  const borderless = t36 === undefined ? false : t36;
  const rightToolbarConfig = t37 === undefined ? rightToolbarDisabled : t37;
  const alreadyLoggedRavenRef = useRef(false);
  const fallbackScrollContainerRef = useRef(null);
  const effectiveScrollContainerRef = scrollContainerRef !== null && scrollContainerRef !== void 0 ? scrollContainerRef : fallbackScrollContainerRef;
  let t38;
  if ($[0] !== columns || $[1] !== reorderable || $[2] !== resizable || $[3] !== sortable) {
    let t39;
    if ($[5] !== reorderable || $[6] !== resizable || $[7] !== sortable) {
      t39 = column => {
        const minimumColumnWidth = getMinimumColumnWidth(column);
        const width = Math.max(column.width || DEFAULT_COLUMN_WIDTH, minimumColumnWidth);
        return Object.assign({}, column, {
          columnNamespace: column.columnNamespace || DEFAULT_NAMESPACE,
          width,
          minimumColumnWidth,
          resizable: column.resizable != null ? column.resizable : resizable,
          reorderable: column.reorderable != null ? column.reorderable : reorderable,
          sortable: column.sortable != null ? column.sortable : sortable
        });
      };
      $[5] = reorderable;
      $[6] = resizable;
      $[7] = sortable;
      $[8] = t39;
    } else {
      t39 = $[8];
    }
    t38 = columns.map(t39);
    $[0] = columns;
    $[1] = reorderable;
    $[2] = resizable;
    $[3] = sortable;
    $[4] = t38;
  } else {
    t38 = $[4];
  }
  const columnsWithDefaults = t38;
  let t39;
  let t40;
  if ($[9] !== columns) {
    t39 = () => {
      for (const column_0 of columns) {
        const minimumColumnWidth_0 = getMinimumColumnWidth(column_0);
        if (column_0.width && column_0.width < minimumColumnWidth_0) {
          const errorExtra = {
            columnName: column_0.columnName,
            columnNamespace: column_0.columnNamespace,
            width: column_0.width,
            minimumColumnWidth: minimumColumnWidth_0
          };
          console.error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users.", errorExtra);
          if (!alreadyLoggedRavenRef.current) {
            Raven.captureException(new Error("FrameworkDataTable has received a column width less than the minimum column width. We are falling back to the minimum column width, but this will cause column rendering and resizing to be extremely glitchy for users."), {
              extra: {
                errorExtra
              }
            });
            alreadyLoggedRavenRef.current = true;
          }
        }
      }
    };
    t40 = [columns];
    $[9] = columns;
    $[10] = t39;
    $[11] = t40;
  } else {
    t39 = $[10];
    t40 = $[11];
  }
  useEffect(t39, t40);
  let t41;
  if ($[12] !== columnsWithDefaults) {
    t41 = () => createWidthsStore({
      initialWidths: columnsWithDefaults.reduce(_temp, {})
    });
    $[12] = columnsWithDefaults;
    $[13] = t41;
  } else {
    t41 = $[13];
  }
  const [widthsStore] = useState(t41);
  let t42;
  if ($[14] !== columnCallToAction || $[15] !== columnsWithDefaults || $[16] !== widthsStore) {
    t42 = {
      columnCallToAction,
      columnsWithDefaults,
      widthsStore
    };
    $[14] = columnCallToAction;
    $[15] = columnsWithDefaults;
    $[16] = widthsStore;
    $[17] = t42;
  } else {
    t42 = $[17];
  }
  useAdjustCtaColumnWidth(t42);
  let t43;
  if ($[18] !== externalSelectionStore) {
    t43 = () => externalSelectionStore ? null : createSelectionStore();
    $[18] = externalSelectionStore;
    $[19] = t43;
  } else {
    t43 = $[19];
  }
  const [internalSelectionStore] = useState(t43);
  const selectionStore = externalSelectionStore !== null && externalSelectionStore !== void 0 ? externalSelectionStore : internalSelectionStore;
  const [cellSelectionStore] = useState(_temp2);
  const cellSelectionScopeId = useId();
  let t44;
  if ($[20] !== cellSelectable || $[21] !== cellSelectionConfig) {
    t44 = cellSelectionConfig !== null && cellSelectionConfig !== void 0 ? cellSelectionConfig : cellSelectable ? {
      type: CELL_SELECTION_CONFIG_TYPES.CELL_SELECTION_ENABLED
    } : cellSelectionDisabled;
    $[20] = cellSelectable;
    $[21] = cellSelectionConfig;
    $[22] = t44;
  } else {
    t44 = $[22];
  }
  const resolvedCellSelectionConfig = t44;
  let t45;
  if ($[23] !== resolvedCellSelectionConfig) {
    t45 = isCellSelectionEnabled(resolvedCellSelectionConfig);
    $[23] = resolvedCellSelectionConfig;
    $[24] = t45;
  } else {
    t45 = $[24];
  }
  const cellSelectionEnabled = t45;
  const [store] = useState(_temp3);
  let t46;
  if ($[25] !== sorts) {
    t46 = sorts.map(_temp4);
    $[25] = sorts;
    $[26] = t46;
  } else {
    t46 = $[26];
  }
  const sortsWithDefaults = t46;
  const shouldShowBulkActionsContainerAboveTable = isBulkActionsRedesignEnabled && isIndexRedesignEnabled;
  let t47;
  if ($[27] !== columnCallToAction || $[28] !== columnsWithDefaults || $[29] !== numberOfFrozenColumns || $[30] !== rows) {
    t47 = {
      columnCallToAction,
      columnsWithDefaults,
      rows,
      numberOfFrozenColumns
    };
    $[27] = columnCallToAction;
    $[28] = columnsWithDefaults;
    $[29] = numberOfFrozenColumns;
    $[30] = rows;
    $[31] = t47;
  } else {
    t47 = $[31];
  }
  const resolvedColumnCallToAction = useResolvedColumnCallToAction(t47);
  let t48;
  if ($[32] !== cellSelectionEnabled || $[33] !== columnsWithDefaults || $[34] !== effectiveScrollContainerRef || $[35] !== getRowId || $[36] !== rows) {
    t48 = cellSelectionEnabled && /*#__PURE__*/_jsx(CellSelectionEffects, {
      columns: columnsWithDefaults,
      rows: rows,
      getRowId: getRowId,
      scrollContainerRef: effectiveScrollContainerRef
    });
    $[32] = cellSelectionEnabled;
    $[33] = columnsWithDefaults;
    $[34] = effectiveScrollContainerRef;
    $[35] = getRowId;
    $[36] = rows;
    $[37] = t48;
  } else {
    t48 = $[37];
  }
  let t49;
  if ($[38] !== BulkActionsComponent || $[39] !== canSelectAllRecords || $[40] !== getRowId || $[41] !== isBulkActionsRedesignEnabled || $[42] !== isIndexRedesignEnabled || $[43] !== rows || $[44] !== shouldShowBulkActionsContainerAboveTable || $[45] !== totalRowCount) {
    t49 = shouldShowBulkActionsContainerAboveTable && /*#__PURE__*/_jsx(BulkActionsContainerAboveTable, {
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      getRowId: getRowId,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      rows: rows,
      totalRowCount: totalRowCount
    });
    $[38] = BulkActionsComponent;
    $[39] = canSelectAllRecords;
    $[40] = getRowId;
    $[41] = isBulkActionsRedesignEnabled;
    $[42] = isIndexRedesignEnabled;
    $[43] = rows;
    $[44] = shouldShowBulkActionsContainerAboveTable;
    $[45] = totalRowCount;
    $[46] = t49;
  } else {
    t49 = $[46];
  }
  let t50;
  if ($[47] !== BulkActionsComponent || $[48] !== CustomSelectAllComponent || $[49] !== RowComponent || $[50] !== TableComponent || $[51] !== alternateHeaderLeftSlot || $[52] !== borderless || $[53] !== canSelectAllRecords || $[54] !== columnsWithDefaults || $[55] !== condensed || $[56] !== dataDensity || $[57] !== effectiveScrollContainerRef || $[58] !== enableFullVirtualization || $[59] !== getRowId || $[60] !== hasTopBarBorderRadius || $[61] !== headerLeftSlot || $[62] !== headerRightSlot || $[63] !== infiniteScrollConfig || $[64] !== isBulkActionsRedesignEnabled || $[65] !== isIndexRedesignEnabled || $[66] !== loading || $[67] !== maxVisiblePageButtons || $[68] !== noRowsSlot || $[69] !== numberOfFrozenColumns || $[70] !== onColumnOrderChange || $[71] !== onColumnWidthChange || $[72] !== onFrozenColumnWidthAlert || $[73] !== onPageIndexChange || $[74] !== onPageSizeChange || $[75] !== onSortsChange || $[76] !== pageIndex || $[77] !== pageSize || $[78] !== pageSizes || $[79] !== pageable || $[80] !== paginatorAlignment || $[81] !== reorderable || $[82] !== resizable || $[83] !== rightToolbarConfig || $[84] !== rows || $[85] !== selectable || $[86] !== sortable || $[87] !== sortsWithDefaults || $[88] !== tableResetKey || $[89] !== totalRowCount || $[90] !== zebraStripe) {
    t50 = /*#__PURE__*/_jsx(Table, {
      alternateHeaderLeftSlot: alternateHeaderLeftSlot,
      BulkActionsComponent: BulkActionsComponent,
      canSelectAllRecords: canSelectAllRecords,
      scrollContainerRef: effectiveScrollContainerRef,
      columns: columnsWithDefaults,
      condensed: condensed,
      dataDensity: dataDensity,
      CustomSelectAllComponent: CustomSelectAllComponent,
      tableResetKey: tableResetKey,
      enableFullVirtualization: enableFullVirtualization,
      getRowId: getRowId,
      headerLeftSlot: headerLeftSlot,
      headerRightSlot: headerRightSlot,
      infiniteScrollConfig: infiniteScrollConfig,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      loading: loading,
      noRowsSlot: noRowsSlot,
      numberOfFrozenColumns: numberOfFrozenColumns,
      onColumnOrderChange: onColumnOrderChange,
      onColumnWidthChange: onColumnWidthChange,
      onFrozenColumnWidthAlert: onFrozenColumnWidthAlert,
      onPageIndexChange: onPageIndexChange,
      onPageSizeChange: onPageSizeChange,
      onSortsChange: onSortsChange,
      pageable: pageable,
      pageIndex: pageIndex,
      pageSize: pageSize,
      pageSizes: pageSizes,
      maxVisiblePageButtons: maxVisiblePageButtons,
      paginatorAlignment: paginatorAlignment,
      reorderable: reorderable,
      resizable: resizable,
      RowComponent: RowComponent,
      rows: rows,
      selectable: selectable,
      sorts: sortsWithDefaults,
      sortable: sortable,
      TableComponent: TableComponent,
      totalRowCount: totalRowCount,
      zebraStripe: zebraStripe,
      hasTopBarBorderRadius: hasTopBarBorderRadius,
      borderless: borderless,
      rightToolbarConfig: rightToolbarConfig
    });
    $[47] = BulkActionsComponent;
    $[48] = CustomSelectAllComponent;
    $[49] = RowComponent;
    $[50] = TableComponent;
    $[51] = alternateHeaderLeftSlot;
    $[52] = borderless;
    $[53] = canSelectAllRecords;
    $[54] = columnsWithDefaults;
    $[55] = condensed;
    $[56] = dataDensity;
    $[57] = effectiveScrollContainerRef;
    $[58] = enableFullVirtualization;
    $[59] = getRowId;
    $[60] = hasTopBarBorderRadius;
    $[61] = headerLeftSlot;
    $[62] = headerRightSlot;
    $[63] = infiniteScrollConfig;
    $[64] = isBulkActionsRedesignEnabled;
    $[65] = isIndexRedesignEnabled;
    $[66] = loading;
    $[67] = maxVisiblePageButtons;
    $[68] = noRowsSlot;
    $[69] = numberOfFrozenColumns;
    $[70] = onColumnOrderChange;
    $[71] = onColumnWidthChange;
    $[72] = onFrozenColumnWidthAlert;
    $[73] = onPageIndexChange;
    $[74] = onPageSizeChange;
    $[75] = onSortsChange;
    $[76] = pageIndex;
    $[77] = pageSize;
    $[78] = pageSizes;
    $[79] = pageable;
    $[80] = paginatorAlignment;
    $[81] = reorderable;
    $[82] = resizable;
    $[83] = rightToolbarConfig;
    $[84] = rows;
    $[85] = selectable;
    $[86] = sortable;
    $[87] = sortsWithDefaults;
    $[88] = tableResetKey;
    $[89] = totalRowCount;
    $[90] = zebraStripe;
    $[91] = t50;
  } else {
    t50 = $[91];
  }
  let t51;
  if ($[92] !== cellSelectionScopeId || $[93] !== cellSelectionStore || $[94] !== resolvedCellSelectionConfig || $[95] !== t48 || $[96] !== t49 || $[97] !== t50) {
    t51 = /*#__PURE__*/_jsxs(ProvideCellSelection, {
      config: resolvedCellSelectionConfig,
      store: cellSelectionStore,
      scopeId: cellSelectionScopeId,
      children: [t48, t49, t50]
    });
    $[92] = cellSelectionScopeId;
    $[93] = cellSelectionStore;
    $[94] = resolvedCellSelectionConfig;
    $[95] = t48;
    $[96] = t49;
    $[97] = t50;
    $[98] = t51;
  } else {
    t51 = $[98];
  }
  let t52;
  if ($[99] !== store || $[100] !== t51) {
    t52 = /*#__PURE__*/_jsx(Provider, {
      store: store,
      context: StoreContext,
      children: t51
    });
    $[99] = store;
    $[100] = t51;
    $[101] = t52;
  } else {
    t52 = $[101];
  }
  let t53;
  if ($[102] !== selectionStore || $[103] !== t52) {
    t53 = /*#__PURE__*/_jsx(Provider, {
      store: selectionStore,
      context: SelectionStoreContext,
      children: t52
    });
    $[102] = selectionStore;
    $[103] = t52;
    $[104] = t53;
  } else {
    t53 = $[104];
  }
  let t54;
  if ($[105] !== t53 || $[106] !== widthsStore) {
    t54 = /*#__PURE__*/_jsx(Provider, {
      store: widthsStore,
      context: WidthsStoreContext,
      children: t53
    });
    $[105] = t53;
    $[106] = widthsStore;
    $[107] = t54;
  } else {
    t54 = $[107];
  }
  let t55;
  if ($[108] !== resolvedColumnCallToAction || $[109] !== t54) {
    t55 = /*#__PURE__*/_jsx(ProvideColumnCallToAction, {
      value: resolvedColumnCallToAction,
      children: t54
    });
    $[108] = resolvedColumnCallToAction;
    $[109] = t54;
    $[110] = t55;
  } else {
    t55 = $[110];
  }
  let t56;
  if ($[111] !== contextMenuConfig || $[112] !== t55) {
    t56 = /*#__PURE__*/_jsx(ProvideFDTContextMenuConfig, {
      contextMenuConfig: contextMenuConfig,
      children: t55
    });
    $[111] = contextMenuConfig;
    $[112] = t55;
    $[113] = t56;
  } else {
    t56 = $[113];
  }
  let t57;
  if ($[114] !== enableFullVirtualization || $[115] !== t56) {
    t57 = /*#__PURE__*/_jsx(ProvideVirtualization, {
      enableFullVirtualization: enableFullVirtualization,
      children: t56
    });
    $[114] = enableFullVirtualization;
    $[115] = t56;
    $[116] = t57;
  } else {
    t57 = $[116];
  }
  let t58;
  if ($[117] !== logger || $[118] !== t57) {
    t58 = /*#__PURE__*/_jsx(ProvideLogger, {
      logger: logger,
      children: t57
    });
    $[117] = logger;
    $[118] = t57;
    $[119] = t58;
  } else {
    t58 = $[119];
  }
  let t59;
  if ($[120] !== hasGate || $[121] !== hasScope || $[122] !== t58) {
    t59 = /*#__PURE__*/_jsx(ProvideAuth, {
      hasScope: hasScope,
      hasGate: hasGate,
      children: t58
    });
    $[120] = hasGate;
    $[121] = hasScope;
    $[122] = t58;
    $[123] = t59;
  } else {
    t59 = $[123];
  }
  return t59;
};
export default TableWrapper;
function _temp(acc, column_1) {
  const width_0 = column_1.width || DEFAULT_COLUMN_WIDTH;
  acc[getColumnKey(column_1.columnNamespace || DEFAULT_NAMESPACE, column_1.columnName)] = width_0;
  return acc;
}
function _temp2() {
  return createCellSelectionStore();
}
function _temp3() {
  return createStore();
}
function _temp4(sort) {
  return Object.assign({}, sort, {
    columnNamespace: sort.columnNamespace != null ? sort.columnNamespace : DEFAULT_NAMESPACE
  });
}